import { WebSection, Zone } from '@wbk/contentful/api';
import { useRouter } from '@wbk/config';
import ZoneCard from '../events/ZoneCard';

export default function Zones({ section, className }: { section: WebSection; className?: string }) {
  const { locale } = useRouter();
  const zones = section.contentCollection.items as Zone[];

  if (!zones.length) return null;

  const desktopRowOne = zones.slice(0, 3);
  const reset = zones.slice(3);
  const MobileRows = zones;
  return (
    <div className={`container-padding container ${className || ''}`}>
      <section className='container space-y-12 px-0'>
        <div className='hidden flex-col gap-2 sm:gap-3 md:gap-4 lg:flex xl:gap-6'>
          <div className='grid grid-cols-3 gap-2 sm:gap-3 md:gap-4 xl:gap-6'>
            {desktopRowOne.map((zone) => (
              <div key={zone.id} className='flex-grow basis-1/3'>
                <ZoneCard
                  href={`/${locale}/zones/${zone.slug}`}
                  buttonText={zone.button?.label ?? 'Explore'}
                  media={zone.featuredBanner}
                  presentedBy={
                    zone.sponsorLogo
                      ? {
                          name: `Presented by ${zone.sponsorLogo.title}`,
                          logoUrl: zone.sponsorLogo.url,
                        }
                      : undefined
                  }
                  zoneLogoUrl={zone.zoneLogo?.url}
                  isNew={zone.newZone ?? false}
                />
              </div>
            ))}
          </div>
          <div className='grid grid-cols-4 gap-2 sm:gap-3 md:gap-4 xl:gap-6'>
            {reset.map((zone) => (
              <div key={zone.id} className='flex-grow basis-1/4'>
                <ZoneCard
                  href={`/${locale}/zones/${zone.slug}`}
                  buttonText={zone.button?.label ?? 'Explore'}
                  media={zone.featuredBanner}
                  presentedBy={
                    zone.sponsorLogo
                      ? {
                          name: `Presented by ${zone.sponsorLogo.title}`,
                          logoUrl: zone.sponsorLogo.url,
                        }
                      : undefined
                  }
                  zoneLogoUrl={zone.zoneLogo?.url}
                  isNew={zone.newZone ?? false}
                />
              </div>
            ))}
          </div>
        </div>

        <div className='flex flex-col gap-[8px] lg:hidden'>
          <div className='grid grid-cols-2 gap-2 sm:gap-3 md:gap-4 lg:gap-8'>
            {MobileRows.map((zone) => (
              <div key={zone.id}>
                <ZoneCard
                  href={`/${locale}/zones/${zone.slug}`}
                  buttonText={zone.button?.label ?? 'Explore'}
                  media={zone.featuredBanner}
                  presentedBy={
                    zone.sponsorLogo
                      ? {
                          name: `Presented by ${zone.sponsorLogo.title}`,
                          logoUrl: zone.sponsorLogo.url,
                        }
                      : undefined
                  }
                  zoneLogoUrl={zone.zoneLogo?.url}
                  isNew={zone.newZone ?? false}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
